import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router'
import Avatar from './Avatar';

class ProfilePic extends React.Component {
    getCredentials() {
        const {name} = this.props;

        let names = name.split(" ");
        if (names.length > 2) {
            names = names.filter( (n, i) => {
                return i === 0 || names.length - i < 2;
            })
        }

        return names.map( n => n[0] ).join("");
    }

    // Generates a "whatever" number based on some data specific to the user
    getPseudoRandomNumber() {
        return this.props.name.length + this.props.id + 1;
    }

    render() {
        const creds = this.getCredentials();
        const number = this.getPseudoRandomNumber();

        const img = <div className="avatar">
                <Avatar text={creds} number={number} />
            </div>;

        if (this.props.link) {
            return <div className="profile-img">
                <Link to={this.props.link}>{img}</Link>
            </div>
        }
        else {
            return <div className="profile-img">{img}</div>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        name: state.user.userData.fullname,
        id: state.user.userData.id
    }
};

export default connect(mapStateToProps)(ProfilePic);


// WEBPACK FOOTER //
// ./src/components/Presentation/ProfilePic.js